import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { PrivateAccess } from '@wf/keycloak-axios-provider';
import { Label } from '@wf/sw-ui-kit';

import ExtensionFields from './ExtensionFields';
import { LicenseField } from '../LicenseField';

import useLicenseAbbreviation from '../../../../hooks/useLicenseAbbreviation';
import { HeaderTabFields } from '../../types/fieldEnums';
import { officerRoles } from '../../../../constants';

import { unionOfEditableFieldsSelector } from '../../store/selectors';

import styles from './HeaderTab.module.scss';

function ActionDatesFields() {
  const { t } = useTranslation();
  const licenseAbbreviation = useLicenseAbbreviation();

  const unionOfEditableFields = useSelector(unionOfEditableFieldsSelector);

  const showExtendToField = unionOfEditableFields.has(HeaderTabFields.extendTo);

  return (
    <>
      <LicenseField.TextField
        label={
          <Label
            helpText={t(
              'Identification number for {{licenseAbbreviation}} application request, generated when the {{licenseAbbreviation}} is Requested',
              { licenseAbbreviation }
            )}
          >
            {t('Request Number')}
          </Label>
        }
        configName={HeaderTabFields.requestNumber}
        name={HeaderTabFields.requestNumber}
        placeholder={t('Request Number')}
      />
      <LicenseField.DateField
        label={
          <Label
            helpText={t('Date when the {{licenseAbbreviation}} application request was submitted', {
              licenseAbbreviation,
            })}
          >
            {t('Request Date')}
          </Label>
        }
        configName={HeaderTabFields.requestDate}
        placeholderText={t('Request Date')}
        name={HeaderTabFields.requestDate}
        isClearable={false}
      />

      <LicenseField.TextField
        label={
          <Label
            helpText={t('Reference number granted upon the final approval of the {{licenseAbbreviation}} application', {
              licenseAbbreviation,
            })}
          >
            {t('Approval Reference')}
          </Label>
        }
        configName={HeaderTabFields.approvalReference}
        name={HeaderTabFields.approvalReference}
        placeholder={t('Approval Reference')}
        className={styles.firstColumn}
      />
      <LicenseField.DateField
        label={
          <Label
            helpText={t('Date when the final approval for the {{licenseAbbreviation}} application was granted', {
              licenseAbbreviation,
            })}
          >
            {t('Approval Date')}
          </Label>
        }
        configName={HeaderTabFields.approvalDate}
        placeholderText={t('Approval Date')}
        name={HeaderTabFields.approvalDate}
        isClearable={false}
      />
      <div />
      <LicenseField.DateField
        label={
          <Label
            helpText={t('Start date of validity period for the {{licenseAbbreviation}}', {
              licenseAbbreviation,
            })}
          >
            {t('Valid From')}
          </Label>
        }
        placeholderText={t('Valid From Date')}
        configName={HeaderTabFields.validFrom}
        name={HeaderTabFields.validFrom}
        isClearable={false}
      />

      <LicenseField.DateField
        label={
          <Label
            helpText={t('End date of validity period for the {{licenseAbbreviation}}', {
              licenseAbbreviation,
            })}
          >
            {t('Valid To')}
          </Label>
        }
        placeholderText={t('Valid To Date')}
        configName={HeaderTabFields.validTo}
        name={HeaderTabFields.validTo}
        minDate={new Date()}
        isClearable={false}
      />
      {showExtendToField && (
        <PrivateAccess roles={officerRoles}>
          <ExtensionFields />
        </PrivateAccess>
      )}
    </>
  );
}

export default ActionDatesFields;
